/**
 * 문제집 관련 API 서비스
 * 학생용 문제집 배정 및 조회
 */

import axiosInstance from '../config/axios';
import { AssignmentsResponse } from '../types/workbook';

/**
 * 현재 학생의 배정된 문제집 목록 조회
 *
 * GET /api/v1/assignments/students/{student_id}
 *
 * @param studentId - 학생 ID (authStore에서 가져온 값)
 * @param isCompleted - 완료 여부 필터 (선택)
 * @returns 배정된 문제집 목록
 */
export const getMyAssignments = async (
  studentId: string,
  isCompleted?: boolean
): Promise<AssignmentsResponse> => {
  try {
    if (!studentId) {
      throw new Error('학생 ID가 없습니다');
    }

    // 쿼리 파라미터 설정
    const params: { is_completed?: boolean } = {};
    if (isCompleted !== undefined) {
      params.is_completed = isCompleted;
    }

    // API 호출
    const response = await axiosInstance.get<AssignmentsResponse>(
      `/assignments/students/${studentId}`,
      { params }
    );

    return response.data;
  } catch (error: any) {
    console.error('Failed to fetch assignments:', error);
    throw error;
  }
};
